import React from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../../utility/getTemplateData';
import fonts from '../../styles/fonts';
const messages = localsMessages('common/oneTouch')

const STYLES = {
	button: {
		maxWidth: 350,
		marginTop: 10,
		marginBottom: 10,
		fontSize: 15,
		fontFamily: fonts.ppSansBigMedium
	}
}

class OneTouchNextButton extends React.Component {
	render () {
		const buttonnext = messages.button && messages.button.next

		return (
			<div className="col-xs-12 text-center">
				<a href="#"
					style={{ ...STYLES.button }}
					className="vx_btn vx_btn-block"
					id="payWithPP"
					disabled={this.props.disabled}
					onClick={this.props.handleNext}>
					{buttonnext}
				</a>
			</div>
		);
	}
}

OneTouchNextButton.propTypes = {
	label: PropTypes.string,
	disabled: PropTypes.bool,
	handleNext: PropTypes.func,
};

export default OneTouchNextButton



// WEBPACK FOOTER //
// ./components/landing/OneTouchNextButton.js